import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

import { userSchema } from "../user";

export const registerSchema = userSchema
  .pick({ name: true, email: true, username: true, locale: true })
  .extend({ 
    password: z.string().min(6, "Password must be at least 6 characters long")
  });

export class RegisterDto extends createZodDto(registerSchema) {}
